import axios from "axios";
import endPoints from "../../../../config/endPoints";


export const loginApi = async(reqBody) => {
  return await axios.post(`${endPoints.userLogin}/auth`, reqBody );
};

export const logoutApi = async(reqBody) => {  
  return await axios.post(`${endPoints.users}/session/close`, reqBody);
};
